import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Parse from 'parse'
import styled from 'styled-components'
import cssVar from '../../styles/variables'
import Modal from './Modal'
import { Text, SecondaryButton, BiggerText, Heading2, PrimaryButton, TextField, NoticeText, GridRow } from './MarketingStyles';

import MultistepForm from '../onboarding/MultistepForm';
import checkmark from '../../images/icons/checkmark.svg'
import failuremark from '../../images/icons/failuremark.svg'

import { inject, observer } from 'mobx-react'

@inject('modalStore')
@observer
class CheckAvailibilityModal extends Component {

  constructor(props) {
    super(props)

    this.state = {
    }
  }

  componentDidMount = () => {
    this.props.modalStore.setOnOpen('check_availibility', this.onOpen)
  }

  onOpen = async () => {
    const data = this.props.modalStore.states.check_availibility.data

    const { available } = await Parse.Cloud.run("checkRegionAvailibitlity", { region_slug: data.region_slug }).catch(err => console.error(err))

    if( available ) this.form.selectSub(1)
    else this.form.selectSub(2)
  }

  closeModal = () => {
    this.props.modalStore.setState('check_availibility', false)
  }

  joinWaitlist = (e) => {

    const data = this.props.modalStore.states.check_availibility.data

    Parse.Cloud.run("joinApplicationWaitlist", { name: e.target.name.value, mail: e.target.mail.value, region_slug: data.region_slug })
      .then(res => this.form.selectSub(3))
      .catch(err => console.error(err))

  }

  render() {

    const Loading = () => (
      <div>LOADING</div>
    )

    const SlotsAvailable = () => (
      <div>
        <img src={ checkmark } style={{marginBottom: 50}} />
        <Heading2>Gratulation! <br /> Es sind freie Plätze verfügbar!</Heading2>

        <PrimaryButton
          value="jetzt bewerben"
          onClick={ () => this.props.history.push('/bewerbung') }
        />
      </div>
    )

    const NoSlotsAvailable = () => (
      <div>
        <img src={ failuremark } style={{marginBottom: 50}} />
        <Heading2>Zur Zeit sind in Ihrer Region leider keine Plätze mehr verfügbar.</Heading2>
        <Text>Wir informieren Sie gerne sobald wir wieder neue Mitglieder aufnehmen. Bitte geben Sie uns Ihre Daten bekannt, damit wir Sie rechtzeitig kontaktieren können.</Text>

        <form onSubmit={e => { e.preventDefault(); this.joinWaitlist(e)} }>
          <GridRow
            style={{margin: '50px 0'}}
            desktop="1fr 1fr"
          >
            <TextField name="name" placeholder="Name" required />
            <TextField name="mail" placeholder="Email" type="email" required />
          </GridRow>

          <GridRow
            style={{margin: '50px 0'}}
            desktop="1fr 1fr"
          >
            <PrimaryButton
              value="Warteliste"
            />
            <SecondaryButton
              value="Home"
              onClick={ e => { e.preventDefault(); this.props.history.push("/")} }
            />
          </GridRow>
        </form>
      </div>
    )

    const JoinedWaitlist = () => (
      <div>
        <img src={ checkmark } style={{marginBottom: 50}} />
        <Heading2>Vielen Dank für Ihr Vertrauen. Sobald Plätze frei werden kontaktieren wir Sie.</Heading2>

        <GridRow
          style={{margin: '50px 0'}}
          desktop="1fr 1fr"
        >
          <PrimaryButton
            value="schließen"
            onClick={ e => { e.preventDefault(); this.closeModal } }
          />
          <SecondaryButton
            value="Kontakt"
            onClick={ e => { e.preventDefault(); this.props.history.push("/kontakt")} }
          />
        </GridRow>
      </div>
    )

    const steps = [
      {
        components: [
          () => <Loading />,
          () => <SlotsAvailable />,
          () => <NoSlotsAvailable />,
          () => <JoinedWaitlist />,
        ],
      }
    ]

    return (
      <Modal slug="check_availibility">
        <MultistepForm steps={ steps } onRef={ref =>  { this.form = ref } } />
      </Modal>
    )
  }
}

export default withRouter(CheckAvailibilityModal)



// WEBPACK FOOTER //
// /src/components/marketing/CheckAvailibilityModal.js